import { createIcon } from '@chakra-ui/icons';

export const RubricGrading = createIcon({
  displayName: 'RubricGrading',
  viewBox: '0 0 44 44',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
      <path
        d="M22.2495 43.3442C33.9462 43.3442 43.4282 33.8622 43.4282 22.1655C43.4282 10.4688 33.9462 0.986816 22.2495 0.986816C10.5528 0.986816 1.0708 10.4688 1.0708 22.1655C1.0708 33.8621 10.5529 43.3442 22.2495 43.3442Z"
        fill="#FEF3DF"
      />
      <path
        d="M22.3491 39.7493C25.3377 39.7493 27.7603 39.3859 27.7603 38.9377C27.7603 38.4894 25.3377 38.126 22.3491 38.126C19.3607 38.126 16.938 38.4894 16.938 38.9377C16.938 39.3859 19.3607 39.7493 22.3491 39.7493Z"
        fill="#F6D59D"
      />
      <path
        d="M31.536 5.86768H13.1635C11.7877 5.86768 10.6724 6.98299 10.6724 8.35883V33.894C10.6724 35.2698 11.7877 36.3851 13.1635 36.3851H31.536C32.9118 36.3851 34.0271 35.2698 34.0271 33.894V8.35883C34.0271 6.98299 32.9118 5.86768 31.536 5.86768Z"
        fill="#F6D59D"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6013 7.89258H14.0968C13.7529 7.89258 13.4741 8.17132 13.4741 8.51523V33.4277C13.4741 33.7716 13.7529 34.0504 14.0968 34.0504H30.6013C30.9452 34.0504 31.2239 33.7716 31.2239 33.4277V8.51523C31.2239 8.17132 30.9452 7.89258 30.6013 7.89258Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8414 5.24457C24.7998 5.24457 24.7599 5.22828 24.7302 5.19918C24.7005 5.17008 24.6834 5.13049 24.6826 5.08889C24.6826 4.78222 24.6221 4.47852 24.5048 4.19517C24.3874 3.91181 24.2154 3.65437 23.9985 3.43748C23.7817 3.22064 23.5242 3.04862 23.2408 2.93123C22.9575 2.81384 22.6538 2.75342 22.3471 2.75342C22.0403 2.75342 21.7367 2.81384 21.4533 2.93123C21.17 3.04862 20.9125 3.22064 20.6957 3.43748C20.4788 3.65437 20.3067 3.91181 20.1894 4.19517C20.072 4.47852 20.0116 4.78222 20.0116 5.08889C20.0116 5.13023 19.9952 5.16982 19.966 5.19896C19.9368 5.22815 19.8972 5.24457 19.8559 5.24457H17.2086C17.1268 5.24453 17.0458 5.26056 16.9702 5.29183C16.8947 5.32307 16.826 5.36893 16.7682 5.42683C16.7103 5.48463 16.6645 5.55328 16.6332 5.62886C16.6019 5.70448 16.5859 5.78541 16.5859 5.86722V8.35837C16.5858 8.44048 16.6019 8.52181 16.6333 8.59764C16.6648 8.67348 16.7109 8.74235 16.7691 8.80024C16.8273 8.85822 16.8963 8.90405 16.9723 8.93515C17.0483 8.96629 17.1297 8.98202 17.2118 8.98154H27.4882C27.6534 8.98154 27.8117 8.91594 27.9285 8.7992C28.0453 8.68241 28.1109 8.52403 28.1109 8.35889V5.8704C28.1109 5.70526 28.0453 5.54692 27.9285 5.43014C27.8117 5.31335 27.6534 5.24775 27.4882 5.24775L24.8414 5.24457Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6108 16.5003L17.3468 17.1976L19.3 14.8398"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1978 16.666L20.5504 17.007C20.6063 17.0611 20.6723 17.1035 20.7446 17.1321C20.8169 17.1606 20.8941 17.1746 20.9719 17.1733C21.0496 17.1719 21.1263 17.1553 21.1976 17.1243C21.2689 17.0933 21.3334 17.0486 21.3875 16.9927L21.729 16.6406C21.783 16.5847 21.8475 16.5399 21.9188 16.509C21.9902 16.478 22.0669 16.4615 22.1447 16.4601C22.2224 16.4588 22.2996 16.4729 22.372 16.5015C22.4443 16.5301 22.5103 16.5727 22.5661 16.6269L22.9187 16.9678C22.9745 17.0219 23.0405 17.0645 23.1128 17.093C23.1851 17.1216 23.2624 17.1356 23.3401 17.1343C23.4178 17.1331 23.4945 17.1165 23.5659 17.0856C23.6372 17.0546 23.7017 17.01 23.7558 16.954L24.0967 16.6014C24.1507 16.5455 24.2153 16.5008 24.2866 16.4698C24.3579 16.4388 24.4347 16.4223 24.5124 16.421C24.5902 16.4196 24.6674 16.4337 24.7397 16.4623C24.8121 16.491 24.878 16.5335 24.9338 16.5876L25.3574 16.9699C25.4132 17.0241 25.4792 17.0667 25.5515 17.0953C25.6238 17.1239 25.701 17.1379 25.7788 17.1367C25.8565 17.1354 25.9333 17.1188 26.0046 17.0878C26.0759 17.0569 26.1405 17.0121 26.1945 16.9562L26.536 16.6035C26.6452 16.4909 26.7947 16.4261 26.9517 16.4235C27.1086 16.4209 27.2602 16.4808 27.3731 16.5898L27.821 17.007"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6108 21.7756L17.3468 22.4729L19.3 20.1157"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1978 21.6709L20.5504 22.0119C20.6062 22.066 20.6722 22.1087 20.7445 22.1373C20.8168 22.1659 20.894 22.1799 20.9718 22.1787C21.0495 22.1774 21.1263 22.1608 21.1976 22.1298C21.2689 22.0988 21.3334 22.0541 21.3875 21.9982L21.729 21.6456C21.783 21.5897 21.8476 21.545 21.9189 21.5141C21.9902 21.4832 22.0669 21.4665 22.1447 21.4653C22.2224 21.464 22.2996 21.478 22.3719 21.5066C22.4442 21.5352 22.5102 21.5777 22.5661 21.6318L22.9187 21.9727C22.9745 22.0269 23.0405 22.0695 23.1128 22.0981C23.1851 22.1267 23.2623 22.1407 23.3401 22.1395C23.4178 22.1382 23.4946 22.1216 23.5659 22.0906C23.6372 22.0596 23.7018 22.0149 23.7558 21.959L24.0968 21.6069C24.1507 21.551 24.2153 21.5062 24.2866 21.4753C24.3579 21.4443 24.4346 21.4277 24.5123 21.4264C24.59 21.425 24.6673 21.439 24.7396 21.4675C24.8119 21.4961 24.8779 21.5386 24.9338 21.5926"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0259 17.0123L34.1967 15.0331C34.4002 14.8472 34.6384 14.7032 34.8977 14.6095C35.1569 14.5157 35.4321 14.474 35.7074 14.4866C35.9827 14.4992 36.2529 14.566 36.5025 14.6831C36.752 14.8002 36.976 14.9654 37.1617 15.1692"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9452 28.1092L24.8589 28.9871C24.573 29.0681 24.4263 28.9077 24.5338 28.6302L25.6918 25.6377L27.9452 28.1092Z"
        fill="#EBBF76"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4593 14.4317C40.6087 14.594 40.7246 14.7843 40.8001 14.9917C40.8755 15.199 40.9092 15.4192 40.899 15.6397C40.8888 15.8601 40.8352 16.0763 40.741 16.2758C40.6468 16.4753 40.5139 16.6542 40.3502 16.8021L27.9522 28.1099H27.9448L25.6914 25.6379V25.6305L38.0889 14.3226C38.2512 14.1733 38.4415 14.0574 38.6489 13.9821C38.8562 13.9066 39.0764 13.873 39.2968 13.8831C39.5172 13.8933 39.7334 13.947 39.933 14.0411C40.1325 14.1353 40.3114 14.268 40.4593 14.4317Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.9897 17.1489L37.2516 19.629"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
